/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Not_Found_DescriptionInputs */



/**
* | output |
* | --- |
* | "This team doesn't exist or you don't have access to it. The link may be broken or the team may have been removed." |
*
* @param {Team_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const team_not_found_description = /** @type {((inputs?: Team_Not_Found_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Not_Found_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Team existiert nicht oder du hast keinen Zugriff darauf. Der Link ist möglicherweise ungültig oder das Team wurde entfernt.")
	return /** @type {LocalizedString} */ ("This team doesn't exist or you don't have access to it. The link may be broken or the team may have been removed.")
});